import { notify } from '@/plugins/Notify/state.js'
import { theme } from '@/plugins/Dark/state.js'
import { conference } from './conference'
import { chat } from './chat'
import { actions } from './actions/index'
import { browserCompatibility } from "./browser-compatibility/index"
import { historical } from "./historical"
import { notes } from "./notes"
import { colaborativeBoard } from "./colaborative-board"
import { signature } from "./signature"

import { oidcSettings } from '@/config/oidc'
import { vuexOidcCreateStoreModule } from 'vuex-oidc'

export default {
    notify,
    theme,
    conference,
    chat,
    actions,
    browserCompatibility,
    historical,
    colaborativeBoard,
    notes,
    signature,
    oidcStore: vuexOidcCreateStoreModule(
        oidcSettings,
        { namespaced: true },
        {
            userLoaded: (user) => window.console.log('OIDC user is loaded:', user),
            userUnloaded: () => window.console.log('OIDC user is unloaded'),
            accessTokenExpiring: () => window.console.log('Access token will expire'),
            accessTokenExpired: () => window.console.log('Access token did expire'),
            silentRenewError: () => window.console.log('OIDC user is unloaded'),
            userSignedOut: () => window.console.log('OIDC user is signed out'),
            oidcError: (payload) => {
                window.console.log('OIDC error', payload);
                window.localStorage.clear();
                document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
                window.location.reload();
            },
            automaticSilentRenewError: (payload) => console.log('Automatic silent renew failed.', payload.error)
        }
    )
}